import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Link } from "react-router-dom";

export default function PurchaseOrderTable(props) {
  return (
    <div>
      <div className="sb-table-div sb-table-setion">
        <Paper
          sx={{ width: "100%", overflow: "hidden" }}
          className="table-main-div"
        >
          <TableContainer
          //   onScroll={(e) =>
          //     handleScroll(
          //       e,
          //       props.users,
          //       props.totalUserCount,
          //       props.setLoading,
          //       props.setPageSize,
          //       props.PageSize
          //     )
          //   }
          >
            <Table
              stickyHeader
              aria-label="sticky table table-responsive"
              className="purchase-order-table"
            >
              <TableHead className="custom-table-header">
                <TableRow>
                  {props.tableHeader.map((data, i) => (
                    <TableCell key={i} align={data?.align}>
                      {data?.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {props.tableData.map((data, i) => (
                  <TableRow key={i}>
                    <TableCell>{data?.po_DocEntry}</TableCell>
                    <TableCell>{data?.Doc_No}</TableCell>
                    <TableCell>{data?.date}</TableCell>
                    <TableCell>{data?.vendor_Ref_No}</TableCell>
                    <TableCell style={{ minWidth: "150px" }}>
                      {data?.vendor_Name}
                    </TableCell>
                    <TableCell style={{ minWidth: "150px" }}>
                      {data?.ship_To}
                    </TableCell>
                    <TableCell style={{ minWidth: "150px" }}>
                      {data?.bill_To}
                    </TableCell>
                    <TableCell style={{ minWidth: "100px" }}>
                      {data?.tax_Amount}
                    </TableCell>
                    <TableCell>{data?.doc_Total}</TableCell>
                    <TableCell style={{ minWidth: "200px" }}>
                      {data?.remarks}
                    </TableCell>
                    <TableCell align="center">
                      <Link to="/vhd/podetails">
                        <div className="color-green hv-center">
                          <i className="fa fa-eye" />
                          &nbsp;
                          <span>View</span>
                        </div>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </div>
  );
}
